import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'
import {
  TDashboardGroupActivity,
  TResourceFilter,
  TDashboardGroupResponse
} from 'types/GlobalDashboardGroup'
import {
  TPatchDashboardGroup,
  TPostInviteToDashboardGroupPermission,
  TPostInviteToDashboardGroupResponse,
  TPostRevokeAccess,
  TPutDashboardGroupFilters
} from './types'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/dashboard-groups`

export async function getAll() {
  return getWithRedirect<TDashboardGroupResponse[]>(URL)
}

export async function getDeleted() {
  return getWithRedirect<TDashboardGroupResponse[]>(`${URL}/deleted`)
}

export async function restore(id: string) {
  return axios.post<{ data: TDashboardGroupResponse }>(
    `${URL}/${id}/restore`,
    { data: {} },
    parseAuthenticationHeader()
  )
}

export async function getPrivateKpis(id: string) {
  return axios.get<{ data: string[] }>(
    `${URL}/${id}/private-kpis`,
    parseAuthenticationHeader()
  )
}

export async function copy(id: string) {
  return axios.post<{ data: TDashboardGroupResponse }>(
    `${URL}/${id}/copy?type=DEFAULT`,
    { data: {} },
    parseAuthenticationHeader()
  )
}

export async function update(id: string, data: TPatchDashboardGroup) {
  return axios.patch<{ data: TDashboardGroupResponse }>(
    `${URL}/${id}`,
    { data },
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}

export async function updateOrder(id: string, body: { data: string[] }) {
  return axios.put(
    `${URL}/${id}/update-order`,
    body,
    parseAuthenticationHeader()
  )
}

export async function revokeFromDashboard(id: string, body: TPostRevokeAccess) {
  return axios.post<{ data: TPostInviteToDashboardGroupResponse }>(
    `${URL}/${id}/revoke`,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function inviteToDashboard(
  id: string,
  data: TPostInviteToDashboardGroupPermission
) {
  return axios.post<{ data: TPostInviteToDashboardGroupResponse }>(
    `${URL}/${id}/invite`,
    { data },
    parseAuthenticationHeader()
  )
}

export async function getActivities(id: string) {
  return getWithRedirect<TDashboardGroupActivity>(`${URL}/${id}/activities`)
}

export async function putFilters(id: string, data: TPutDashboardGroupFilters) {
  return axios.put<{ data: TResourceFilter[] }>(
    `${URL}/${id}/dashboard-filters`,
    { data },
    parseAuthenticationHeader()
  )
}
